// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/context/auth-context'
import AppLoader from '@/components/AppLoader'

// Gates console routes: shows the loader while auth state resolves, then
// redirects unauthenticated users to /login (preserving where they were headed).
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return <AppLoader />
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />
  return <>{children}</>
}
